var map = {
	"./1/symbol_0.png": "263b",
	"./1/symbol_1.png": "592b",
	"./1/symbol_10.png": "11c6",
	"./1/symbol_11.png": "a75a",
	"./1/symbol_12.png": "912c",
	"./1/symbol_2.png": "a2b5",
	"./1/symbol_3.png": "33ad",
	"./1/symbol_4.png": "bfb5",
	"./1/symbol_5.png": "bfb0",
	"./1/symbol_6.png": "625d",
	"./1/symbol_7.png": "1e57",
	"./1/symbol_8.png": "48f8",
	"./1/symbol_9.png": "98ae",
	"./2/symbol_0.png": "dfc1",
	"./2/symbol_1.png": "074f",
	"./2/symbol_10.png": "d72f",
	"./2/symbol_11.png": "dd92",
	"./2/symbol_12.png": "9c7a",
	"./2/symbol_2.png": "8ded",
	"./2/symbol_3.png": "637b",
	"./2/symbol_4.png": "6700",
	"./2/symbol_5.png": "b1b7",
	"./2/symbol_6.png": "169c",
	"./2/symbol_7.png": "7b93",
	"./2/symbol_8.png": "64fc",
	"./2/symbol_9.png": "424c",
	"./3/symbol_0.png": "bae7",
	"./3/symbol_1.png": "2d9b",
	"./3/symbol_10.png": "d7af",
	"./3/symbol_12.png": "91b9",
	"./3/symbol_2.png": "9210",
	"./3/symbol_3.png": "8430",
	"./3/symbol_4.png": "907c",
	"./3/symbol_5.png": "17f54",
	"./3/symbol_6.png": "6340",
	"./3/symbol_7.png": "860f",
	"./3/symbol_8.png": "7f2e",
	"./3/symbol_9.png": "b057",
	"./4/symbol_0.png": "299d",
	"./4/symbol_1.png": "ac6b",
	"./4/symbol_10.png": "b383",
	"./4/symbol_12.png": "7c2a",
	"./4/symbol_2.png": "b5d3",
	"./4/symbol_3.png": "5590",
	"./4/symbol_4.png": "0d45",
	"./4/symbol_5.png": "355b6",
	"./4/symbol_6.png": "60ad",
	"./4/symbol_7.png": "1ea6",
	"./4/symbol_8.png": "d76a",
	"./4/symbol_9.png": "2ddb",
	"./gold1.png": "9dec",
	"./gold2.png": "495c",
	"./gold3.png": "95dd",
	"./gold4.png": "40f9",
	"./silver1.png": "7f7e",
	"./silver2.png": "87b6",
	"./silver3.png": "6eec",
	"./silver4.png": "9102"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99a3";